class ScheduledReportDetailViewController extends MUIViewController
{
    static newInstance() : ScheduledReportDetailViewController {
        let vc = new ScheduledReportDetailViewController("scheduled-report-detail-view");
        vc.initWithResource("layout/scheduledreport/ScheduledReportDetailView.html");
        return vc;
    }

    private backButton:MUIButton = null;
    private saveButton:MUIButton = null;

    private reportComboBox:MUIComboBox = null;
    private titleTextField:MUITextField = null;
    private formatComboBox:MUIComboBox = null;
    private periodComboBox:MUIComboBox = null;
    private sendTimeTextField:MUITextField = null;
    private recurrenceComboBox:MUIComboBox = null;
    private weekdayBox:MUIView = null;
    private weekdayComboBox:MUIComboBox = null;
    private dayOfMonthBox:MUIView = null;
    private dayOfMonthTextField:MUITextField = null;
    private emailsTextField:MUITextField = null;
    private activeSwitch:MUISwitchButton = null;
    private lastRunLabel:MUILabel = null;
    private tableView:UITableView = null;

    private syncs = [];

    viewDidLoad(){
        super.viewDidLoad();

        this.backButton = MUIOutlet(this, "back-btn", "MUIButton");
        this.backButton.setAction(this, function(this:ScheduledReportDetailViewController){
            this.navigationController.popViewController(true);
        });

        this.saveButton = MUIOutlet(this, "save-btn", "MUIButton");
        this.saveButton.setAction(this, function(this:ScheduledReportDetailViewController){
            DBHelper.saveMainContext();
            this.navigationController.popViewController(true);
        });

        this.reportComboBox = MUIOutlet(this, "report-cb", "MUIComboBox");
        this.reportComboBox.setOnChangeAction(this, function(this:ScheduledReportDetailViewController, control:MUIComboBox, value:string){
            if (this._item != null) this._item.reportID = value == "-1" ? null : value;
        });

        this.titleTextField = MUIOutlet(this, "title-tf", "MUITextField");
        this.titleTextField.setOnChangeText(this, function(this:ScheduledReportDetailViewController, control:MUITextField, value:string){
            if (this._item != null) this._item.title = value.trim().length > 0 ? value.trim() : null;
        });

        this.formatComboBox = MUIOutlet(this, "format-cb", "MUIComboBox");
        this.formatComboBox.removeAllItems();
        this.formatComboBox.addItem(MIOLocalizeString("XLSX", "XLSX"), "xlsx");
        this.formatComboBox.addItem(MIOLocalizeString("CSV", "CSV"), "csv");
        this.formatComboBox.addItem(MIOLocalizeString("HTML", "HTML"), "html");
        this.formatComboBox.setOnChangeAction(this, function(this:ScheduledReportDetailViewController, control:MUIComboBox, value:string){
            if (this._item != null) this._item.format = value;
        });

        this.periodComboBox = MUIOutlet(this, "period-cb", "MUIComboBox");
        this.periodComboBox.removeAllItems();
        this.periodComboBox.addItem(MIOLocalizeString("TODAY", "TODAY"), "today");
        this.periodComboBox.addItem(MIOLocalizeString("YESTERDAY", "YESTERDAY"), "yesterday");
        this.periodComboBox.addItem(MIOLocalizeString("THIS_WEEK", "THIS WEEK"), "this-week");
        this.periodComboBox.addItem(MIOLocalizeString("LAST_WEEK", "LAST WEEK"), "last-week");
        this.periodComboBox.addItem(MIOLocalizeString("THIS_MONTH", "THIS MONTH"), "this-month");
        this.periodComboBox.addItem(MIOLocalizeString("LAST_MONTH", "LAST MONTH"), "last-month");
        this.periodComboBox.setOnChangeAction(this, function(this:ScheduledReportDetailViewController, control:MUIComboBox, value:string){
            if (this._item != null) this._item.period = value;
        });

        this.sendTimeTextField = MUIOutlet(this, "send-time-tf", "MUITextField");
        this.sendTimeTextField.setOnChangeText(this, function(this:ScheduledReportDetailViewController, control:MUITextField, value:string){
            if (this._item != null) this._item.sendTime = value.trim();
        });

        this.recurrenceComboBox = MUIOutlet(this, "recurrence-cb", "MUIComboBox");
        this.recurrenceComboBox.removeAllItems();
        this.recurrenceComboBox.addItem(MIOLocalizeString("ONCE", "ONCE"), "once");
        this.recurrenceComboBox.addItem(MIOLocalizeString("DAILY", "DAILY"), "daily");
        this.recurrenceComboBox.addItem(MIOLocalizeString("WEEKLY", "WEEKLY"), "weekly");
        this.recurrenceComboBox.addItem(MIOLocalizeString("MONTHLY", "MONTHLY"), "monthly");
        this.recurrenceComboBox.setOnChangeAction(this, function(this:ScheduledReportDetailViewController, control:MUIComboBox, value:string){
            if (this._item == null) return;
            this._item.recurrence = value;
            if (value == "weekly" && this._item.weekday == 0) this._item.weekday = 1;
            if (value == "monthly" && this._item.dayOfMonth == 0) this._item.dayOfMonth = 1;
            this.updateRecurrenceUI();
        });

        this.weekdayBox = MUIOutlet(this, "weekday-box", "MUIView");
        this.weekdayComboBox = MUIOutlet(this, "weekday-cb", "MUIComboBox");
        this.weekdayComboBox.removeAllItems();
        this.weekdayComboBox.addItem(MIOLocalizeString("MONDAY", "MONDAY"), 1);
        this.weekdayComboBox.addItem(MIOLocalizeString("TUESDAY", "TUESDAY"), 2);
        this.weekdayComboBox.addItem(MIOLocalizeString("WEDNESDAY", "WEDNESDAY"), 3);
        this.weekdayComboBox.addItem(MIOLocalizeString("THURSDAY", "THURSDAY"), 4);
        this.weekdayComboBox.addItem(MIOLocalizeString("FRIDAY", "FRIDAY"), 5);
        this.weekdayComboBox.addItem(MIOLocalizeString("SATURDAY", "SATURDAY"), 6);
        this.weekdayComboBox.addItem(MIOLocalizeString("SUNDAY", "SUNDAY"), 7);
        this.weekdayComboBox.setOnChangeAction(this, function(this:ScheduledReportDetailViewController, control:MUIComboBox, value:string){
            if (this._item != null) this._item.weekday = parseInt(value);
        });

        this.dayOfMonthBox = MUIOutlet(this, "day-of-month-box", "MUIView");
        this.dayOfMonthTextField = MUIOutlet(this, "day-of-month-tf", "MUITextField");
        this.dayOfMonthTextField.setOnChangeText(this, function(this:ScheduledReportDetailViewController, control:MUITextField, value:string){
            if (this._item == null) return;
            let day = parseInt(value);
            this._item.dayOfMonth = isNaN(day) ? 1 : Math.min(Math.max(day, 1), 31);
        });

        this.emailsTextField = MUIOutlet(this, "emails-tf", "MUITextField");
        this.emailsTextField.setOnChangeText(this, function(this:ScheduledReportDetailViewController, control:MUITextField, value:string){
            if (this._item != null) this._item.emails = value.trim().length > 0 ? value.trim() : null;
        });

        this.activeSwitch = MUIOutlet(this, "active-sw", "MUISwitchButton");
        this.activeSwitch.setOnChangeValue(this, function(this:ScheduledReportDetailViewController, control:MUISwitchButton, value:boolean){
            if (this._item != null) this._item.active = value;
        });

        this.lastRunLabel = MUIOutlet(this, "last-run-lbl", "MUILabel");

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;

        this.downloadReports();
    }

    numberOfSections(tableView:UITableView) { return 1; }
    numberOfRowsInSection(tableView:UITableView, section:number) { return this.syncs.length; }

    cellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let cell = tableView.dequeueReusableCellWithIdentifier("ScheduledReportSyncCell") as ScheduledReportSyncCell;
        cell.item = this.syncs[indexPath.row];
        return cell;
    }

    // Last sendings: every attempt leaves an IntegratorSync row journaled by
    // the server, keyed to this schedule.
    private downloadSyncs(){
        if (this._item == null) return;

        let sortDescriptors = [ MIOSortDescriptor.sortDescriptorWithKey("date", false) ];
        let predicate = MIOPredicate.predicateWithFormat("referenceEntityID == " + this._item.identifier + " and deletedAt == null");
        DBHelper.queryObjectsWithCompletion("IntegratorSync", sortDescriptors, predicate, [], this, function(this:ScheduledReportDetailViewController, objects){
            this.syncs = objects.slice(0, 10);
            this.tableView.reloadData();
        });
    }

    viewWillAppear(animated?){
        super.viewWillAppear(animated);
        this.updateUI();
    }

    private _item:ScheduledReport = null;
    set item(item:ScheduledReport){
        this._item = item;
        this.updateUI();
    }

    private reportsDownloaded = false;
    private downloadReports(){
        let lang = SettingsHelper.sharedInstance().currentSupportedLanguage;
        let sortDescriptors = [ MIOSortDescriptor.sortDescriptorWithKey("name", true) ];
        let predicate = MIOPredicate.predicateWithFormat("report != null and report.visible == true and language = '" + lang + "'");
        DBHelper.queryObjectsWithCompletion("ReportLocalized", sortDescriptors, predicate, ["report"], this, function(this:ScheduledReportDetailViewController, objects){
            this.reportComboBox.removeAllItems();
            this.reportComboBox.addItem(MIOLocalizeString("SELECT_REPORT", "SELECT REPORT..."), "-1");
            for (let index = 0; index < objects.length; index++){
                let rl = objects[index] as ReportLocalized;
                if (rl.report == null) continue;
                this.reportComboBox.addItem(rl.name, rl.report.identifier);
            }
            this.reportsDownloaded = true;
            this.updateUI();
        });
    }

    private updateUI(){
        if (this.viewIsLoaded == false || this._item == null) return;

        if (this.reportsDownloaded) this.reportComboBox.selectItem(this._item.reportID != null ? this._item.reportID : "-1");
        this.titleTextField.text = this._item.title;
        this.formatComboBox.selectItem(this._item.format);
        this.periodComboBox.selectItem(this._item.period);
        this.sendTimeTextField.text = this._item.sendTime;
        this.recurrenceComboBox.selectItem(this._item.recurrence);
        this.weekdayComboBox.selectItem(this._item.weekday > 0 ? this._item.weekday : 1);
        this.dayOfMonthTextField.text = this._item.dayOfMonth > 0 ? this._item.dayOfMonth.toString() : "1";
        this.emailsTextField.text = this._item.emails;
        this.activeSwitch.on = this._item.active == true;

        this.updateRecurrenceUI();
        this.updateStatusUI();
        this.downloadSyncs();
    }

    private updateRecurrenceUI(){
        this.weekdayBox.hidden = this._item.recurrence != "weekly";
        this.dayOfMonthBox.hidden = this._item.recurrence != "monthly";
    }

    private updateStatusUI(){
        if (this._item.lastError != null) {
            this.lastRunLabel.text = MIOLocalizeString("LAST_ERROR", "LAST ERROR") + ": " + this._item.lastError;
        }
        else if (this._item.lastRunAt != null) {
            let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
            this.lastRunLabel.text = MIOLocalizeString("LAST_SENT", "LAST SENT") + ": " + ad.dateTimeFormatter.stringFromDate(this._item.lastRunAt);
        }
        else {
            this.lastRunLabel.text = MIOLocalizeString("NEVER_SENT", "NEVER SENT");
        }
    }
}
